import actionTypes from '../actionTypes/actionTypes';

export const initialState = {
  loggedIn: false
}

function loginReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_LOGIN:
      return Object.assign({}, state, {
        loggedIn: action.data.success || false
      })
      break
    case actionTypes.REQUEST_LOGOUT:
      return Object.assign({}, state, {
        loggedIn: false
      })
      break
    default:
      return state
  }
}

export default loginReducer;